import dayjs from 'dayjs';
import React from 'react';
import PropTypes from 'prop-types';
import { longDate, shortDate } from '../../../../utils';

/**
 * Big Two columns Opening Hours Table for Stores. In the first row and second column
 * there can be a message with state.
 *
 * @param props
 *  children: will be inserted above tbody, eg for the table caption
 *  openingHours: an opening hours array
 *  className: classes to be inserted on the table element
 *  stateMessage: localized message of state of the shop
 *  country: country for determining bank holidays
 *  nationwideBankHolidays: list of Nation Wide Bank Holidays based on country
 *  locationBasedBankHolidays: list of Location Based Bank Holidays based on country
 */
export default function BigTwoColumnsOpeningHoursTable(props) {
  const {
    openingHours,
    children,
    className,
    stateMessage
  } = props;

  return (
    <table className={className}>
      {children}
      <tbody>
        {openingHours.map((dayOpeningHours, index) => (
          <tr key={index}>
            {getFirstColumnCellContent(props, index)}
            <td>
              {dayOpeningHours}
              {(index === 0 && stateMessage)
                ? <span className={'subcell'} data-state-message={''}>{stateMessage}</span>
                : <span />}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}


function getFirstColumnCellContent(params, index) {
  const {
    country,
    nationwideBankHolidays,
    locationBasedBankHolidays,
    currentDate
  } = params;

  const currentDateFormatted = dayjs(currentDate).add(index, 'days').format('YYYY/MM/DD');

  let firstColumnCellContent;

  if (country &&
    locationBasedBankHolidays[country] &&
    locationBasedBankHolidays[country][currentDateFormatted]) {

    firstColumnCellContent = <td>{locationBasedBankHolidays[country][currentDateFormatted]}</td>;
  } else if (nationwideBankHolidays[currentDateFormatted]) {

    firstColumnCellContent = <td>{nationwideBankHolidays[currentDateFormatted]}</td>;
  } else {

    firstColumnCellContent = (
      <td>
        <span className={'opening-hours-date-long'}>{longDate(currentDate, index)}</span>
        <span className={'opening-hours-date-short'}>{shortDate(currentDate, index)}</span>
      </td>
    );
  }

  return firstColumnCellContent;
}

BigTwoColumnsOpeningHoursTable.propTypes = {
  children: PropTypes.node,
  openingHours: PropTypes.arrayOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  stateMessage: PropTypes.string,
  country: PropTypes.string.isRequired,
  nationwideBankHolidays: PropTypes.objectOf(PropTypes.string).isRequired,
  locationBasedBankHolidays: PropTypes.objectOf(PropTypes.objectOf(PropTypes.string)).isRequired,
  currentDate: PropTypes.objectOf(Date).isRequired
};

BigTwoColumnsOpeningHoursTable.defaultProps = {
  children: null,
  className: '',
  stateMessage: ''
};
